import React from "react";
import { Genres } from "pages";

const GenresRoute = () => {
  return (
    <>
      <Genres />
    </>
  );
};

export default GenresRoute;
